import { render } from "./HomeServiceCard.vue?vue&type=template&id=bb25e198&scoped=true"
import script from "./HomeServiceCard.vue?vue&type=script&lang=js"
export * from "./HomeServiceCard.vue?vue&type=script&lang=js"

import "./HomeServiceCard.vue?vue&type=style&index=0&id=bb25e198&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb25e198"]])

export default __exports__